/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_EditInputs */

const vi_vehicle_edit = /** @type {(inputs: Vehicle_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sửa xe`)
};

/**

* @param {Vehicle_EditInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_edit = /** @type {((inputs?: Vehicle_EditInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_EditInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_edit(inputs)
});